import styled from 'styled-components';
import { variant } from 'styled-system';
import { ColorProps, PropsWithPseudo } from '../../../theme/styledProps';

type PerformanceTableRowVariant = 'default' | 'clickable' | 'disabled';

export const PerformanceTableRow = styled.tr<{
  isExpanded?: boolean;
  isEmbeddedMobile?: boolean;
  variant?: PerformanceTableRowVariant;
}>(
  ({ onClick }) => ({
    ...(onClick
      ? {
          userSelect: 'none',
          tabIndex: 0,
          role: 'button',
          outline: 'none',
          cursor: 'pointer',
        }
      : {}),
  }),

  ({ isExpanded, isEmbeddedMobile }) =>
    variant<PropsWithPseudo<ColorProps, '&:hover'>, PerformanceTableRowVariant>({
      variants: {
        default: {
          bg: 'bg',

          '&:hover': {
            bg: isEmbeddedMobile ? undefined : 'neutral.100',
          },
        },

        clickable: {
          bg: isExpanded ? 'primary.100' : 'bg',

          '&:hover': {
            bg: isEmbeddedMobile ? undefined : isExpanded ? 'primary.200' : 'neutral.100',
          },
        },

        disabled: {
          bg: 'neutral.50',
        },
      },
    }),
);

PerformanceTableRow.defaultProps = {
  isExpanded: false,
  variant: 'default',
};
